/*
 * @Description: 请输入当前文件描述
 * @Author: Wang Xiaowu (wangxiaowu@example.com)
 * @Date: 2023-01-29 17:22:57
 * @LastEditors: YOYO [792611446@qq.com]
 * @LastEditTime: 2026-01-16 15:47:11
 * 
 */

import Vue from 'vue'
import Router from 'vue-router'
import VueRouter from 'vue-router'
import Index from '@/views/Index' //index
// import Login from '@/views/login/Index' //登录
// import goIndex from '@/views/login/goIndex' // 免登录
const Login = resolve => require(['@/views/login/Index'], resolve)
const goIndex = resolve => require(['@/views/login/goIndex'], resolve)
// ==============================================================================================
const homeIndex = resolve => require(['@/views/homePage/Index'], resolve)
// 首页
const homePage = resolve => require(['@/views/homePage/HomePage'], resolve)
// 全屏首页
const BigScreen = resolve => require(['@/components/firstPage/BigScreen'], resolve)
// ==============================================================================================

const deviceIndex = resolve => require(['@/views/deviceManagement/Index'], resolve)
// 设备管理
const deviceM = resolve => require(['@/views/deviceManagement/DeviceManagement'], resolve)
// 设备入库
const equipmentM = resolve => require(['@/views/deviceManagement/EquipmentWarehousing'], resolve)
// 设备入库
const deviceType = resolve => require(['@/views/deviceManagement/DeviceType'], resolve)
// 烟感设备
const deviceSmoke = resolve => require(['@/views/deviceManagement/DeviceSmoke'], resolve)
// 睡眠监测
const deviceSleep = resolve => require(['@/views/deviceManagement/deviceSleep'], resolve)
// 睡眠监测-统计
const statistics = resolve => require(['@/views/deviceManagement/statistics'], resolve)
// import deviceGas from '@/views/deviceGas/DeviceGas' //燃气设备
// 电气设备
const deviceElectrical = resolve => require(['@/views/deviceManagement/DeviceElectrical'], resolve)
//x系列燃气设备
const deviceGas = resolve => require(['@/views/deviceManagement/DeviceGas'], resolve)
//小工报
const devicePaper = resolve => require(['@/views/deviceManagement/DevicePaper'], resolve)
//一键报警
const DeviceOnAlarm = resolve => require(['@/views/deviceManagement/DeviceOnAlarm'], resolve)
//声光报警
const VoiceOnAlarm = resolve => require(['@/views/deviceManagement/VoiceOnAlarm'], resolve)
// 雷达
const DeviceRadar = resolve => require(['@/views/deviceManagement/DeviceRadar'], resolve)
// 监控视频
const deviceVideo = resolve => require(['@/views/deviceManagement/DeviceVideo'], resolve)
// 水压
const waterPressure = resolve => require(['@/views/deviceManagement/WaterPressureCard'], resolve)
//液压
const liquidLevel = resolve => require(['@/views/deviceManagement/LiquidLevelCard'], resolve)
// 消防栓
const fireHydrant = resolve => require(['@/views/deviceManagement/fireHydrant'], resolve)
//门磁
const doorMagnetic = resolve => require(['@/views/deviceManagement/DoorMagnetic'], resolve)
//智能扩音器
const IntelligentAmplifier = resolve => require(['@/views/deviceManagement/IntelligentAmplifier'], resolve)
//网关类设备
const gateway = resolve => require(['@/views/deviceManagement/Gateway'], resolve)
//智能开关
const controlSwitch = resolve => require(['@/views/deviceManagement/ControlSwitch'], resolve)
//网关类设备
const deviceHumanInfrared = resolve => require(['@/views/deviceManagement/DeviceHumanInfrared'], resolve)
//水浸
const waterImmersion = resolve => require(['@/views/deviceManagement/waterImmersion'], resolve)
//温湿度设备
const deviceTH = resolve => require(['@/views/deviceManagement/DeviceTH'], resolve)
//香烟报警设备
const cigaretteAlarm = resolve => require(['@/views/deviceManagement/cigaretteAlarm'], resolve)
//智能开关
const smartSwitch = resolve => require(['@/views/deviceManagement/smartSwitch'], resolve)
//智慧用电
const standardSwitch = resolve => require(['@/views/deviceManagement/standardSwitch'], resolve)
// 智能灭火器
const deviceFireExtinguisher = resolve => require(['@/views/deviceManagement/deviceFireExtinguisher'], resolve)
// 空气电台
const deviceAirRadio = resolve => require(['@/views/deviceManagement/DeviceAirRadio'], resolve)
// 点型气体探测器
const deviceMultyGas = resolve => require(['@/views/deviceManagement/deviceMultyGas'], resolve)
// 用户传输装置
const deviceTransferList = resolve => require(['@/views/deviceManagement/DeviceTransferList'], resolve)
// 感温设备
const deviceTempSensitive = resolve => require(['@/views/deviceManagement/deviceTempSensitive'], resolve)
// 复合烟感
const smokeands = resolve => require(['@/views/deviceManagement/smokeands'], resolve)
// ==============================================================================================
// import equipmentIndex from '@/views/equipmentWarehousing/Index'
// import equipmentM from '@/views/equipmentWarehousing/EquipmentWarehousing' //设备入库
// ==============================================================================================
const faultIndex = resolve => require(['@/views/faultHistory/Index'], resolve)
//故障历史
const faultHistory = resolve => require(['@/views/faultHistory/FaultHistory'], resolve)
//报修记录
const repairRecord = resolve => require(['@/views/faultHistory/repairRecord'], resolve)
// 异常记录
const abnormalRecord = resolve => require(['@/views/faultHistory/abnormalRecord'], resolve)
// ==============================================================================================
const unitIndex = resolve => require(['@/views/unitInformation/Index'], resolve)
//单位信息
const unitInfo = resolve => require(['@/views/unitInformation/UnitInformation'], resolve)
// ==============================================================================================
const regionalIndex = resolve => require(['@/views/regionalManagement/Index'], resolve)
//区域管理
const regionalM = resolve => require(['@/views/regionalManagement/RegionalManagement'], resolve)
// ==============================================================================================
const personnelIndex = resolve => require(['@/views/personnelManagement/Index'], resolve)
//角色管理
const rolesM = resolve => require(['@/views/personnelManagement/rolesM'], resolve)
//人员管理
const personnelM = resolve => require(['@/views/personnelManagement/PersonnelManagement'], resolve)
// ==============================================================================================
const alarmIndex = resolve => require(['@/views/alarmHistory/Index'], resolve)
//报警历史
const alarmHistory = resolve => require(['@/views/alarmHistory/AlarmHistory'], resolve)
// 防拆记录
const tamperRecord = resolve => require(['@/views/alarmHistory/tamperRecord'], resolve)
// ==============================================================================================
// 巡检管理
const patroIndex = resolve => require(['@/views/PatrolManagement/Index'], resolve)
// import selfRecord from '@/views/PatrolManagement/SelfRecord' //自查记录
//巡检类型
const patrolType = resolve => require(['@/views/PatrolManagement/PatrolType'], resolve)
//巡检项
const patrolItem = resolve => require(['@/views/PatrolManagement/PatrolItem'], resolve)
//巡检计划
const patrolPlan = resolve => require(['@/views/PatrolManagement/PatrolPlan'], resolve)
//巡检点
const patrolPoint = resolve => require(['@/views/PatrolManagement/PatrolPoint'], resolve)
//巡检-关联部门
const patrolDepts = resolve => require(['@/views/PatrolManagement/PatrolDepts'], resolve)
//巡检模板
const patrolTemplate = resolve => require(['@/views/PatrolManagement/PatrolTemplate'], resolve)
//巡检记录
const inspectRecord = resolve => require(['@/views/PatrolManagement/InspectionRecord'], resolve)
//巡检统计
const patrolSta = resolve => require(['@/views/PatrolManagement/PatrolStatistics'], resolve)
// ==============================================================================================
const hiddenIndex = resolve => require(['@/views/hiddenDangerManagement/Index'], resolve)
//隐患管理
const dangerM = resolve => require(['@/views/hiddenDangerManagement/DangerManagement'], resolve)
//隐患列表
const hiddenDanger = resolve => require(['@/views/hiddenDangerManagement/HiddenDanger'], resolve)
// ==============================================================================================
const logIndex = resolve => require(['@/views/logManagement/Index'], resolve)
//日志管理
const logM = resolve => require(['@/views/logManagement/LogManagement'], resolve)
// ==============================================================================================
const systemIndex = resolve => require(['@/views/systemManagement/Index'], resolve)
//子租户管理
const childOrg = resolve => require(['@/views/systemManagement/ChildrenorgManagement'], resolve)
//组织管理
const orgM = resolve => require(['@/views/systemManagement/OrgManagement'], resolve)
//系统管理
const systemSet = resolve => require(['@/views/systemManagement/SystemSet'], resolve)
//首页配置
const homepageConfig = resolve => require(['@/views/systemManagement/HomepageConfig'], resolve)
//微信公众号
const wxSubscription = resolve => require(['@/views/systemManagement/wxSubscription/Index'], resolve)
//微信配置信息
const wxConfig = resolve => require(['@/views/systemManagement/wxSubscription/WxConfig'], resolve)
//微信轮播图
const rotationPic = resolve => require(['@/views/systemManagement/wxSubscription/RotationPic'], resolve)
//区域管理
const regionM = resolve => require(['@/views/systemManagement/RegionManagement'], resolve)
//帮助文档
const helpDoc = resolve => require(['@/views/systemManagement/HelpDoc'], resolve)
//卡管理
const cardManagement = resolve => require(['@/views/systemManagement/cardManagement'], resolve)
//资费管理
const tariffManagement = resolve => require(['@/views/systemManagement/tariffManagement'], resolve)
//资费记录
const tariffRecords = resolve => require(['@/views/systemManagement/tariffRecords'], resolve)
//购买页面
const purchase = resolve => require(['@/views/systemManagement/purchase'], resolve)
// 消防场所
const fireFacilities = resolve => require(['@/views/systemManagement/fireFacilities'], resolve)
/*******************************************数据推送*****************************************************/
// 数据推送首页
const dataIndex = resolve => require(['@/views/DataSend/Index'], resolve)
//数据推送
const sendList = resolve => require(['@/views/DataSend/SendList'], resolve)
//标签
const labelPage = resolve => require(['@/views/DataSend/LabelPage'], resolve)
//无权限
const noView = resolve => require(['@/views/DataSend/noView'], resolve)

/*******************************************场景联动*****************************************************/
// 场景首页
const sceneIndex = resolve => require(['@/views/SceneStory/Index'], resolve)
// 场景列表
const sceneList = resolve => require(['@/views/SceneStory/SceneList'], resolve)
// 场景记录
const sceneHistory = resolve => require(['@/views/SceneStory/sceneHistory'], resolve)

/*******************************************星图商城*****************************************************/
// 商品顶页
const shopIndex = resolve => require(['@/views/shopMana/Index'], resolve)
// 商品列表
const shopList = resolve => require(['@/views/shopMana/ShopList'], resolve)
//商城列表详情页
const shopDetails = resolve => require(['@/views/shopMana/ShopDetails'], resolve)
//商城列表详情页
const notification = resolve => require(['@/views/Notification/notification'], resolve)

// 留言板-意见反馈
const messageBoard = resolve => require(['@/views/MessageBoard/MessageBoard'], resolve)

Vue.use(Router)
Vue.use(VueRouter)
// ==============================================================================================
const routes = [
  {
    path: '/goIndex',
    name: 'goIndex',
    meta: { isShare: true },
    component: goIndex
  },
  {
    path: '/',
    name: 'Index',
    component: Index,
    redirect: '/login',
    children: [
      //    {
      //   path: '/homeView',
      //   name: 'HomeView',
      //   component: homeView,
      // },
      // {
      //   path: '/homeIndex',
      //   name: 'homeIndex',
      //   component: homeIndex,
      //   // redirect: '/homePage',
      //   children: [
      //     {
      //       path: '/homePage',
      //       name: 'homePage',
      //       component: homePage
      //     }
      //   ]
      // }, 
      {
        path: '/deviceIndex',
        name: 'deviceIndex',
        // redirect: '/deviceM',
        component: deviceIndex,
        children: [
          {
            path: '/deviceM',
            name: 'deviceM',
            component: deviceM
          },
          {
            path: '/equipmentM',
            name: 'equipmentM',
            component: equipmentM,
          },
          {
            path: '/deviceSmoke',
            name: 'deviceSmoke',
            component: deviceSmoke,
          },
          {
            path: '/deviceGas',
            name: 'deviceGas',
            component: deviceGas,
          },
          {
            path: '/devicePaper',
            name: 'devicePaper',
            component: devicePaper,
          },
          {
            path: '/deviceOnAlarm',
            name: 'deviceOnAlarm',
            component: DeviceOnAlarm,
          },
          {
            path: '/voiceOnAlarm',
            name: 'voiceOnAlarm',
            component: VoiceOnAlarm,
          },
          {
            path: '/deviceRadar',
            name: 'deviceRadar',
            component: DeviceRadar,
          },
          {
            path: '/deviceElectrical',
            name: 'deviceElectrical',
            component: deviceElectrical,
          },
          {
            path: '/deviceType',
            name: 'deviceType',
            component: deviceType,
          },
          {
            path: '/deviceVideo',
            name: 'deviceVideo',
            component: deviceVideo,
          },
          {
            path: '/waterPressure',
            name: 'waterPressure',
            component: waterPressure,
          },
          {
            path: '/liquidLevel',
            name: 'liquidLevel',
            component: liquidLevel,
          },
          {
            path: '/fireHydrant',
            name: 'fireHydrant',
            component: fireHydrant,
          },
          {
            path: '/doorMagnetic',
            name: 'doorMagnetic',
            component: doorMagnetic,
          },
          {
            path: '/gateway',
            name: 'gateway',
            component: gateway,
          },
          {
            path: '/IntelligentAmplifier',
            name: 'IntelligentAmplifier',
            component: IntelligentAmplifier,
          },
          {
            path: '/controlSwitch',
            name: 'controlSwitch',
            component: controlSwitch,
          },
          {
            path: '/deviceHumanInfrared',
            name: 'deviceHumanInfrared',
            component: deviceHumanInfrared,
          },
          {
            path: '/waterImmersion',
            name: 'waterImmersion',
            component: waterImmersion,
          },
          {
            path: '/deviceTH',
            name: 'deviceTH',
            component: deviceTH,
          },
          {
            path: '/deviceSleep',
            name: 'deviceSleep',
            component: deviceSleep,
          },
          {
            path: '/statistics',
            name: 'statistics',
            component: statistics,
          },
          {
            path: '/cigaretteAlarm',
            name: 'cigaretteAlarm',
            component: cigaretteAlarm,
          },
          {
            path: '/smartSwitch',
            name: 'smartSwitch',
            component: smartSwitch,
          },
          {
            path: '/standardSwitch',
            name: 'standardSwitch',
            component: standardSwitch,
          },
          {
            path: '/deviceFireExtinguisher',
            name: 'deviceFireExtinguisher',
            component: deviceFireExtinguisher,
          },
          {
            path: '/deviceAirRadio',
            name: 'deviceAirRadio',
            component: deviceAirRadio,
          },
          {
            path: '/deviceMultyGas',
            name: 'deviceMultyGas',
            component: deviceMultyGas,
          },
          {
            path: '/deviceTransferList',
            name: 'deviceTransferList',
            component: deviceTransferList,
          },
          {
            path: '/deviceTempSensitive',
            name: 'deviceTempSensitive',
            component: deviceTempSensitive,
          },
          {
            path: '/smokeands',
            name: 'smokeands',
            component: smokeands,
          },
          // {
          //   path: '/circle3d',
          //   name: 'circle3d',
          //   component: resolve => require(['@/components/Canvas/circle3D.vue'], resolve)
          // }
        ]
      },
      {
        path: '/faultIndex',
        name: 'faultIndex',
        component: faultIndex,
        children: [
          {
            path: '/faulthistory',
            name: 'faulthistory',
            component: faultHistory
          },
          {
            path: '/repairRecord',
            name: 'repairRecord',
            component: repairRecord
          },
          {
            path: '/abnormalRecord',
            name: 'abnormalRecord',
            component: abnormalRecord
          }
        ]
      },
      {
        path: '/hiddenIndex',
        name: 'hiddenIndex',
        component: hiddenIndex,
        children: [{
          path: '/hiddenDanger',
          name: 'hiddenDanger',
          component: hiddenDanger
        }, {
          path: '/dangerM',
          name: 'dangerM',
          component: dangerM
        }]
      },
      {
        path: '/logIndex',
        name: 'logIndex',
        component: logIndex,
        children: [{
          path: '/logM',
          name: 'logM',
          component: logM
        }]
      },
      {
        path: '/systemIndex',
        name: 'systemIndex',
        component: systemIndex,
        children: [{
          path: '/childOrg',
          name: 'childOrg',
          component: childOrg
        }, {
          path: '/systemSet',
          name: 'systemSet',
          component: systemSet
        }, {
          path: '/regionM',
          name: 'regionM',
          component: regionM
        }, {
          path: '/orgM',
          name: 'orgM',
          component: orgM
        }, 
       {
          path: '/homeConfig',
          name: 'homeConfig',
          component: homepageConfig
        }, {
          path: '/helpDoc',
          name: 'helpDoc',
          component: helpDoc
        },
        {
          path: '/cardManagement',
          name: 'cardManagement',
          component: cardManagement
        },
        {
          path: '/tariffManagement',
          name: 'tariffManagement',
          component: tariffManagement
        },
        {
          path: '/tariffRecords',
          name: 'tariffRecords',
          component: tariffRecords
        },
        {
          path: '/purchase',
          name: 'purchase',
          component: purchase
        },
        {
          path: '/fireFacilities',
          name: 'fireFacilities',
          component: fireFacilities
        },
       {
          path: '/wxSubscription',
          name: 'wxSubscription',
          component: wxSubscription,
          children: [{
            path: '/wxConfig',
            name: 'wxConfig',
            component: wxConfig
          }, {
            path: '/rotationPic',
            name: 'rotationPic',
            component: rotationPic
          }]
        }]
      },
      {
        path: '/unitIndex',
        name: 'unitIndex',
        component: unitIndex,
        children: [{
          path: '/unitInfo',
          name: 'unitInfo',
          component: unitInfo
        }]
      },
      {
        path: '/regIndex',
        name: 'regIndex',
        component: regionalIndex,
        children: [{
          path: '/regionalM',
          name: 'regionalM',
          component: regionalM
        }]
      },
      {
        path: '/personIndex',
        name: 'personIndex',
        component: personnelIndex,
        children: [{
          path: '/personnelM',
          name: 'personnelM',
          component: personnelM
        },
        {
          path: '/rolesM',
          name: 'rolesM',
          component: rolesM
        }
        ]
      },
      {
        path: '/alarmIndex',
        name: 'alarmIndex',
        component: alarmIndex,
        children: [
          {
            path: '/alarmHistory',
            name: 'alarmHistory',
            component: alarmHistory
          }
        ]
      },
      {
        path: '/tamperRecord',
        name: 'tamperRecord',
        component: tamperRecord
      },
      {
        path: '/patroIndex',
        name: 'patroIndex',
        component: patroIndex,
        children: [
          // {
          //   path: '/selfR',
          //   name: 'selfR',
          //   component: selfRecord
          // },
          {
            path: '/patrolType',
            name: 'patrolType',
            component: patrolType
          },
          {
            path: '/patrolItem',
            name: 'patrolItem',
            component: patrolItem
          },
          {
            path: '/patrolPlan',
            name: 'patrolPlan',
            component: patrolPlan
          },
          {
            path: '/patrolPoint',
            name: 'patrolPoint',
            component: patrolPoint
          },
          {
            path: '/patrolDepts',
            name: 'patrolDepts',
            component: patrolDepts
          },
          {
            path: '/patrolTemplate',
            name: 'patrolTemplate',
            component: patrolTemplate
          },
          {
            path: '/inspectRecord',
            name: 'inspectRecord',
            component: inspectRecord
          },
          {
            path: '/patrolSta',
            name: 'patrolSta',
            component: patrolSta

          }
        ]
      },
      // 数据推送
      {
        path: '/datasend',
        name: 'datasend',
        component: dataIndex,
        children: [
          {
            path: '/sendList',
            name: 'sendList',
            component: sendList
          },
          {
            path: '/labelPage',
            name: 'labelPage',
            component: labelPage
          },
          {
            path: '/noView',
            name: 'noView',
            component: noView
          }
        ]
      },
      // 场景联动
      {
        path: '/scene',
        name: '/scene',
        component: sceneIndex,
        children: [
          {
            path: '/sceneList',
            name: 'sceneList',
            component: sceneList
          },
          {
            path: '/sceneHistory',
            name: 'sceneHistory',
            component: sceneHistory
          }
        ]
      },
      // 商城
      {
        path: '/shop',
        name: '/shop',
        component: shopIndex,
        children: [
          {
            path: '/shopList',
            name: 'shopList',
            component: shopList,
            meta:{
              keepAlive:true
            }
          },
          {
            path: '/shopDetails',
            name: 'shopDetails',
            component: shopDetails
          },
        
        ]
      },
      {
        path: '/notification',
        name: 'notification',
        component: notification,
        meta: { title: '通知中心' }
      },
      {
        path: '/messageBoard',
        name: 'messageBoard',
        component: messageBoard,
        meta: { title: '意见反馈' }
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/screen',
    name: "Screen",
    component: BigScreen
  }
]

const vueRouter = new Router({
  routes
})

//登录拦截
vueRouter.beforeEach((to, from, next) => {
  // next()
  if (to.matched.some(route => route.meta.isShare)) {
    next()
  } else {
    if (to.matched.some(route => route.meta.loginJudge)) {
      //   console.log(vueRouter.app.storage)
      //   console.log(vueRouter.app.storage.getSession("login"))
      if (!vueRouter.app.storage.getSession("login")) {
        vueRouter.push("/login");
      } else {
        next();
      }
    } else {
      next();
    }
  }
})


export default vueRouter